import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPaymentState, IPaymentData } from './types';

const SLICE_NAME = 'PAYMENT_SLICE';

const initialState: IPaymentState = {
  isLoading: false,
  error: null,
  data: {
    name: '',
    industry: '',
    paymentPlan: 'free',
    metadata: {
      pageScansPerMonth: '5',
      userFeedback: 'limited',
      websites: '1',
      widget: 'limited',
    },
    subscriptionScannedPages: 0,
  },
};

const paymentSlice = createSlice({
  name: SLICE_NAME,
  initialState: initialState,
  reducers: {
    paymentInfoAction: (state , { payload }) => {
      state.isLoading = true;
    },
    paymentInfoSucceededAction: (state, { payload: { data } }: PayloadAction<{ data: IPaymentData }>) => {
      state.data = data;
      state.isLoading = false;
    },
    paymentInfoFailedAction: (state, { payload: error }) => {
      state.isLoading = false;
      state.error = error;
    },
  },
});

export default paymentSlice;
